import { render } from "./PromptPreview.vue?vue&type=template&id=56d2e832&scoped=true&ts=true"
import script from "./PromptPreview.vue?vue&type=script&lang=ts"
export * from "./PromptPreview.vue?vue&type=script&lang=ts"

import "./PromptPreview.vue?vue&type=style&index=0&id=56d2e832&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d2e832"]])

export default __exports__